<div *ngIf="loadingDevice" class="container-fluid pt-3 d-flex align-items-center justify-content-center history-analytics-shell">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">{{ 'loading' | translate }}</span>
  </div>
</div>

<div class="history-analytics-fit" *ngIf="showDeviceHistoryView">
  <div class="container-fluid pt-3 pb-0 mb-2 flex-shrink-0 history-analytics-filters">
    <app-history-analytics-date-filter
    (rangeChange)="onRangeChange($event)">
    </app-history-analytics-date-filter>
  </div>

  <app-history-anc-plus
    *ngIf="showAncPlusHistory"
    [serial]="serial"
    [deviceInfo]="deviceInfoForChild"
    [dateRange]="dateRange">
  </app-history-anc-plus>

  <app-history-astrolum
    *ngIf="showAstrolumHistory"
    class="d-flex flex-column flex-fill min-h-0"
    [serial]="serial"
    [deviceInfo]="deviceInfoForChild"
    [dateRange]="dateRange">
  </app-history-astrolum>
</div>

<div *ngIf="showUnsupportedMessage" class="container-fluid pt-3">
  <div class="card">
    <div class="card-body text-center text-muted py-5">
      <i class="fas fa-history fa-2x mb-3 opacity-50"></i>
      <p class="mb-0 small">{{ 'ancHistoricsPlaceholder' | translate }}</p>
    </div>
  </div>
</div>
